import { types, async } from '~/utils/typeCreator'

export default types(
  [...async('LOAD_USER'), 'CHANGE_USER', 'CLEAR_STATE'],
  'USER'
)
